<template>
    <div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <div class="row" v-else>
            <div class="col-lg-12 mb-4">
                <div class="box">
                    <div class="box-offset">
                        <div class="box-ttl-wrap">
                            <div class="box-ttl">Notifications</div>
                            <div class="box-search">
                                <button
                                    class="box-search-btn"
                                    type="submit"
                                    @click="getListOfNotifications"
                                ><img src="/img/svg/icons-search.svg" alt="">
                                </button>
                                <input type="search"
                                       class="box-search-txt"
                                       v-model="filters.search"
                                       @input="handleSearch"
                                />
                            </div>
                        </div>
                        <div class="table-holder table-responsive notifications-table">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr
                                    v-for="notification in listOfNotifications"
                                    :key="notification.id"
                                    @click="redirectToPage(notification.data.link)"
                                >
                                    <td>
                                        <div class="item-inner">
                                            <div class="item-ttl">
                                                <h5>{{notification.data.title}}</h5>
                                                <div class="date-time">{{formatDate(notification.created_at)}} </div>
                                            </div>
                                            <p>{{notification.data.body}}</p>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <Pagination
                            :currentPage="pagination.current_page"
                            :lastPage="pagination.last_page"
                            @changePage="changePage"
                            @changeItemsPerPage="changeItemsPerPage"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import PaginationHandler from "../../../../../resources/js/mixins/PaginationHandler";
import Pagination from "../../../../../resources/js/components/Pagination.vue";
import NotificationsService from "./Services/NotificationsService";
import {createDebouncedFunction} from "../../../../../resources/js/plugins/debounce";

export default {
    name: 'ListOfNotifications',
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    components: {Pagination},
    mixins: [DateConverter, PaginationHandler],
    data()  {
        return {
            listOfNotifications: [],
            loading: true,
            pagination: {
                current_page: 1, last_page: 1,
            },
            filters: {
                search: '',
                page: 1,
                perPage: 10
            },
        }
    },
    methods: {
        getList(filters) {
            this.getListOfNotifications(filters)
        },
        async getListOfNotifications() {
            try {
                const {data: response} = await NotificationsService.getNotifications(this.user.id, this.filters)
                this.listOfNotifications = response.data
                this.pagination.current_page = response.current_page
                this.pagination.last_page = response.last_page
                this.loading = false
            } catch (e) {
                console.error(e)
            }
        },
        redirectToPage(link) {
            window.location.href = link
        },
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },
    },
    mounted() {
        this.getListOfNotifications()
        this.delayedSearch = createDebouncedFunction(() => this.getListOfNotifications(), 500);
    }

}

</script>

<style scoped>

</style>
